import React, { useEffect } from 'react'
import { TableContainer, Table, TableHead, TableCell, TableRow, Paper, TableBody, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { downloadDocument, getBiocharCollection } from '../../../../../actions/tigercat-burns/tigercat-actions';
import Paginator from '../../../../layout/Pagination';
import useTsPaginator from 'ts-paginator';
const BiocharCollectionBins = ({ projectId, project }) => {
    const dispatch = useDispatch()
    const biocharCollections = useSelector(state => state.tigercatBurnsReducer.biocharCollection.data)
    const tableRecordCount = useSelector(state => state.tigercatBurnsReducer.biocharCollection?.pagination?.total_records)

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);

    useEffect(() => {
        // if (currentProjectId !== projectId) {
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount); // Reset to the first page
        // }
    }, [projectId, tableRecordCount]);

    useEffect(() => {
        dispatch(getBiocharCollection(projectId, 'trailer', +rowsPerPage, +currentPage));
    }, [dispatch, projectId])

    const handleDownload = async () => {
        try {
            dispatch(downloadDocument(projectId, 'biochar_collection_bins')).then((response) => {

                // Create a downloadable link for the Excel file
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${project}_biochar_collection_bins.xlsx`); // Set the file name
                document.body.appendChild(link);
                link.click();
                link.remove();
            })

        } catch (err) {
            console.error('Error downloading Biochar Collection Bins:', err);
        }
    };

    return (<>
        <h2>Biochar Collection Bins</h2>
        <TableContainer key={0} component={Paper} sx={{ height: 'auto' }}>
            <Button variant='contained' sx={{ height: 'auto', float: 'right', mt: 2, mb: 2 }} onClick={handleDownload}>Download Excel</Button>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        {/* <TableCell align="left" size="small">
                            User
                        </TableCell> */}
                        <TableCell align="left" size="small">
                            Date
                        </TableCell>
                        <TableCell align="left" size="small">
                            Destination Address
                        </TableCell>
                        <TableCell align="left" size="small">
                            Entity Name
                        </TableCell>
                        <TableCell align="left" size="small">
                            Entity Email
                        </TableCell>
                        <TableCell align="left" size="small">
                            Entity Contact
                        </TableCell>
                        <TableCell align="left" size="small">
                            Trailer/Bin Used
                        </TableCell>
                        <TableCell align="left" size="small">
                            Transport Method
                        </TableCell>
                        <TableCell align="left" size="small">
                            Distance
                        </TableCell>
                        <TableCell align="left" size="small">
                            Biochar Intended Use
                        </TableCell>
                        <TableCell align="left" size="small">
                            Collection Notes
                        </TableCell>
                        <TableCell align="left" size="small">
                            Non-combustion Confirmation
                        </TableCell>
                        <TableCell align="left" size="small">
                            Biochar Loaded Photo
                        </TableCell>
                        <TableCell align="left" size="small">
                            Volume in Trailer
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {biocharCollections?.map((data, index) => {
                        return (
                            <TableRow key={index}>
                                {/* <TableCell align="left" size="small">{data.user_name}</TableCell> */}
                                <TableCell align="left" size="small">{data.created_at.split('T')[0]}</TableCell>
                                <TableCell align="left" size="small">{data.destination_address}</TableCell>
                                <TableCell align="left" size="small">{data.entity_name}</TableCell>
                                <TableCell align="left" size="small">{data.entity_email}</TableCell>
                                <TableCell align="left" size="small">{data.contact_number == 'null' ? '' : data.contact_number}</TableCell>
                                <TableCell align="left" size="small">{data.bin_used}</TableCell>
                                <TableCell align="left" size="small">{data.transportation_method}</TableCell>
                                <TableCell align="left" size="small">{data.transportation_distance == 'null' ? '' : data.transportation_distance}</TableCell>
                                <TableCell align="left" size="small">{data.intended_use}</TableCell>
                                <TableCell align="left" size="small">{data.collection_notes == 'null' ? '' : data.collection_notes}</TableCell>
                                <TableCell align="left" size="small">{data.will_be_burned_or_incinerated ? 'No' : 'Yes'}</TableCell>
                                <TableCell align="left" size="small">
                                    {data.biochar_loaded_photo ? (
                                        <a href={data.biochar_loaded_photo} target="_blank" rel="noopener noreferrer">
                                            Photo
                                        </a>
                                    ) : 'N/A'}
                                </TableCell>
                                <TableCell align="left" size="small">{data?.biochar_volume?.toFixed(2)}</TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
        <Paginator
            totalRecordCount={totalRecordCount}
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            handleChangePage={_handleChangePage}
            handleChangeRowsPerPage={_handleChangeRowsPerPage}
            determinePaginationMessage={_determinePaginationMessage}
            determinePaginationDisabledState={_determinePaginationDisabledState}
            determineRowsPerPageOptions={_determineRowsPerPageOptions}
        />
    </>

    )
}

export default BiocharCollectionBins